/**
 * Format product metafields responses.
 * @param {Array} responses - Array of GraphQL responses from
 * product metafield queries.
 * @returns {Object} - An object mapping product handles to
 * their metafield values.
 */
export function formatProductMetafieldsResponse(responses, namespace, key) {
  const metafields = {}

  responses.forEach((response) => {
    const handle = response?.productByHandle?.handle
    const metafieldResponse = response?.productByHandle?.metafields
    let metafieldObj = null
    if (Array.isArray(metafieldResponse)) {
      metafieldObj = metafieldResponse.find(
        (metafield) => metafield &&
          metafield.namespace === namespace &&
          metafield.key === key,
      )
    }

    if (handle) {
      metafields[handle] = metafieldObj ? metafieldObj.value : null
    }
  })

  return metafields
}
